import { useEffect, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import { FONT } from "../../../value/staticValues";
import DashboardBox from "../../base/tamplate/DashboardBox";

import { ReactComponent as MoreImg } from '../../../img/ico-prefix-more-dashboard.svg';

interface MatrixChartBoxProps {
    navigate: Function;
    url?: string;
    title: string;
    data: number;
    total: number;
}

export default function MatrixChartBox(props:MatrixChartBoxProps) {
    const [percent, setPercent] = useState(0);

    useEffect(() => {
        setPercent(props.data/props.total);
    }, [props]);

    return (
        <DashboardBox style={{
            width: 330, height: 320,
            marginRight: 10,
        }}> 
            <View style={{flexDirection: "row", alignItems: "center", height: 20}}>
                <Text style={{
                    fontFamily: FONT.MEDIUM,
                    fontSize: 14,
                    lineHeight: 13,
                    color: "#262626"
                }}>
                    {props.title}
                </Text>
                {props.url ?
                    <MoreImg 
                        style={{marginLeft: "auto", cursor: "pointer"}}
                        onClick={() => {props.navigate(`${props.url}`)}}
                    />
                :null }
            </View>

            <View style={{flexDirection: "row", marginTop: 21,}}>
                <View style={{flexDirection: "row", alignItems: "flex-end"}}>
                    <Text style={{
                        fontFamily: FONT.BOLD,
                        fontSize: 32,
                        color: "#333333"
                    }}>
                        {props.total - props.data}
                    </Text>
                    <Text style={{
                        marginLeft: 3, marginBottom: 8,
                        fontFamily: FONT.REGULAR,
                        fontSize: 12,
                        color: "#8c8c8c"
                    }}>
                        Available
                    </Text>
                </View>
                <View style={{marginLeft: "auto"}}>
                    <Text style={{
                        fontFamily: FONT.MEDIUM,
                        fontSize: 14,
                        lineHeight: 12,
                        color: "#0853fb" 
                    }}>
                        {props.data} Used
                    </Text>
                    <Text style={{
                        marginTop: 10,
                        fontFamily: FONT.REGULAR,
                        fontSize: 12,
                        color: "#8c8c8c",
                    }}>
                        Total {props.total}
                    </Text>
                </View>
            </View>
            <View style={{flexDirection: "row", marginTop: "auto", marginBottom: 10}}>
                {[...Array(20)].map((data, rowindex) => {
                    return (
                        <View key={rowindex + 1000} style={{marginRight: rowindex !== 20 ? 5 : 0}}>
                            {[...Array(10)].map((data, index) => {
                                return (
                                    <View key={index + 3000} style={{
                                        ...styles.BoxStyle,
                                        marginBottom: index !== 10 ? 5 : 0,
                                        backgroundColor: rowindex < (20 * percent) ? "#5b9782" : "#f5f8fa"
                                    }}/>
                                )
                            })}
                        </View>
                    )
                })}
            </View>
        </DashboardBox>
    )
}

const styles = StyleSheet.create({
    BoxStyle: {
        width: 10, height: 10,
        backgroundColor: "#f5f8fa"
    }
})